import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-v2",
  "use": "icon-down-v2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-down-v2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 16h16V0H0z\" /><path fill=\"currentColor\" d=\"M3.137 4.929h9.728a.5.5 0 0 1 .353.854l-4.864 4.864a.502.502 0 0 1-.708 0L2.783 5.782a.502.502 0 0 1 .354-.854z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol